<template>
  <v-col cols="12" style="padding-top: 50px">
    <v-list class="transparent py-0" max-width="100%">
      <template v-for="(business, index) in businesses">
        <v-list-item :key="business._id"
                     class="grey lighten-3 mb-1"
                     two-line>
          <v-list-item-action>
            <v-icon :color="mainColor" size="25px">
              feather-dollar-sign
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="kbDarkBlueText--text">{{ business.name }}</v-list-item-title>
            <v-list-item-subtitle class="kgGrayText--text">{{ business.roles.join(', ') }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="business._id" v-if="index < businesses.length - 1"/>
      </template>
    </v-list>
  </v-col>
</template>

<script>
export default {
  props: {
    businesses: {
      type: Array,
      default: () => []
    },
    mainColor: {
      type: String
    }
  }
}
</script>
